import React from 'react';
import { FieldKeyType, FormField } from '@dtp/membership-service-types';
import { UseFormReturn } from 'react-hook-form';
import S from './Styles';
import { FormFieldRender } from './FormFieldRender';

interface FormFieldControllerProps {
  fieldComponents: FormField[];
  control: UseFormReturn['control'];
  errors: UseFormReturn['formState']['errors'];
  fieldNamePrefix?: string;
  clearErrors?: UseFormReturn['clearErrors'];
  watch?: UseFormReturn['watch'];
  setValue?: UseFormReturn['setValue'];
  // eslint-disable-next-line react/no-unused-prop-types
  setError?: UseFormReturn['setError'];
  extraMargin?: boolean;
}

export const FormFieldController = ({
  fieldComponents,
  control,
  errors,
  fieldNamePrefix,
  clearErrors,
  watch,
  setValue,
  extraMargin = false,
}: FormFieldControllerProps) => (
  <>
    {fieldComponents.map((field, index) => {
      if (field.key === FieldKeyType.GroupFields && field.fieldComponents) {
        return (
          // eslint-disable-next-line react/no-array-index-key
          <S.GroupFieldWrapper key={`${field.key}-${index}`} className="GroupFieldWrapper">
            {field.fieldComponents.map((groupField) => (
              <FormFieldRender
                field={groupField}
                fieldId={groupField.id}
                control={control}
                errors={errors}
                key={groupField.id}
                watch={watch}
                setValue={setValue}
                clearErrors={clearErrors}
                extraMargin={extraMargin}
              />
            ))}
          </S.GroupFieldWrapper>
        );
      }
      const fieldId = fieldNamePrefix ? `${fieldNamePrefix}.${field.id}` : field.id;
      return (
        <FormFieldRender
          field={field}
          fieldId={fieldId}
          control={control}
          errors={errors}
          clearErrors={clearErrors}
          key={fieldId}
          watch={watch}
          setValue={setValue}
          extraMargin={extraMargin}
        />
      );
    })}
  </>
);
